import { SOGetEntity } from '../entity/so-get-entity';
import { SOGetCustomLogicRequirement } from '../custom-logic-requirement/so-get-custom-logic-requirement';
import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';
import {ENSimpleAttributeType} from '../../enums';


export class SOPostSimpleAttribute {

  constructor(
    public name: string,
    public editPermissions: boolean,
    public entity: SOGetEntity,
    public project: SOGetProject,
    public organization: SOGetOrganization,
    public description: string = "",
    public attributeType: ENSimpleAttributeType = null,
    public customLogicRequirement: SOGetCustomLogicRequirement = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPostSimpleAttribute(
      'name' in params ? params.name : null,
      'description' in params ? params.description : null,
      'attributeType' in params ? params.attributeType : null,
      'editPermissions' in params ? params.editPermissions : null,
      'entity' in params ? params.entity : null,
      'customLogicRequirement' in params ? params.customLogicRequirement : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
    );
  }
}
